import React from "react";

import LottieAnimation from "../loties-animation";
import userdate from "../../userdata.json";

const ExpContaioner = ({ exp, isLeft = false }) => {
  return (
    <div
      className={`flex w-100 justify-between timeline-flex flex-column  ${
        isLeft ? "flex-row-l" : "flex-row-reverse-l "
      }`}
    >
      <div className="w-50-l container pointer relative">
        <div
          className={`flex items-center period-line ${
            isLeft ? "justify-end-l flex-row-reverse flex-row-l" : "flex-row-reverse"
          }`}
        >
          <div className={`f4 w-70 ${isLeft ? "mr3-l ml3 text-align-end-l" : "ml3"}`}>
            <b>{exp?.period || ""}</b>
          </div>
          <hr className="pv0 mv0 mh0  w-30 b--primary ba  bg-primary" />
        </div>
        <div className={isLeft ? "mr4-l ml3" : "ml4-l ml3 "}>
          <div className="f2-l f3 mt3 text-align-center">
            <b>{exp?.role || ""}</b>

            <div className="f3-l f4 mt3">{exp?.organisation || ""}</div>
          </div>
          <ul className="mt3 ml0 ml3-l" type="circle">
            {(exp?.highlights || []).map((highlight, index) => (
              <li className="mt2">
                {highlight?.title ? (
                  <b className="f4-l f5 mr2">{highlight?.title}</b>
                ) : null}

                <span className=" lh-copy f5">{highlight?.description || ""}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="w-50-l">
        <LottieAnimation name={exp?.lottie} className="ml4-l mb4 mb0-l ml4 ml0-l"/>
      </div>
    </div>
  );
};

function Experience() {
  const { experience } = userdate || {};
  return (
    <div id="Experience" className="pt6 ">
      <div className=" f1 flex">
        <hr className="w-50" />
        <span className="mh3">Experience</span>
        <hr className="w-50" />
      </div>

      <div className="mt4  timeline relative">
        {(experience || []).map((exp, index) => (
          <ExpContaioner exp={exp} isLeft={(index + 1) % 2 === 0} />
        ))}
      </div>
    </div>
  );
}

export default Experience;
